import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Carousel } from '../../Generic/Carousel';
import Typography from '../../Generic/Typography';
import CarouselCard from './CarouselCard';
import styles from './Homecarousel-tw-styles';
import i18nMessages from '../../../constants/messages/pt-BR';
import DOMPurify from 'isomorphic-dompurify';

const settings = {
  arrows: true,
  slidesToShow: 1.5,
  slidesToScroll: 1,
  speed: 600,
  adaptiveHeight: false,
  infinite: false,
  lazyLoad: false,
  dots: true,
  draggable: true,
  autoplay: false,
  autoplaySpeed: 3000,
  variableWidth: false,
  prevArrow: <span className="glyphicon glyphicon-menu-left" />,
  nextArrow: <span className="glyphicon glyphicon-menu-right" />,
  accessibility: true,

  // ✅ Same as your reference: arrows off for smaller viewports (including 200% zoom)
  responsive: [
    {
      breakpoint: 896,
      settings: {
        dots: true,
        arrows: false,
        draggable: true,
        autoplay: false,
        infinite: false,
        slidesToShow: 1.2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 769,
      settings: {
        dots: true,
        arrows: false,
        draggable: true,
        autoplay: false,
        infinite: false,
        slidesToShow: 2.2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 435,
      settings: {
        dots: true,
        arrows: false,
        draggable: true,
        autoplay: false,
        infinite: false,
        slidesToShow: 1.2,
        slidesToScroll: 1,
      },
    },
  ],
};

export default class HomepageCarousel extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { currentTab: 0, viewportWidth: null };
  }

  componentDidMount() {
    if (typeof window === 'undefined') return;

    const update = () => this.setState({ viewportWidth: window.innerWidth });
    update();

    window.addEventListener('resize', update);
    window.addEventListener('orientationchange', update);

    this._cleanup = () => {
      window.removeEventListener('resize', update);
      window.removeEventListener('orientationchange', update);
    };
  }

  componentWillUnmount() {
    this._cleanup?.();
  }

  handleSlideChange = (index) => {
    this.setState({ currentTab: index });
  };

  render() {
    const { carousel } = this.props;
    const { currentTab, viewportWidth } = this.state;

    const carouselSettings = {
      ...settings,
      afterChange: this.handleSlideChange,
    };

    // ✅ Under 896 (mobile + 200% zoom typical), enable "mobile tab/focus behavior"
    const tabAdvancesSlides = viewportWidth !== null && viewportWidth < 896;

    return (
      <div className={styles.homeCarouselParent}>
        <Typography
          component="div"
          className={classNames(
            styles.relatedArticles.card.carouselHeader,
            'heroTitleId'
          )}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(i18nMessages.nossosfav),
          }}
        />

        <Carousel
          {...carouselSettings}
          className={styles.homeCarouselCardWidth}
          currentTab={currentTab}
          tabAdvancesSlides={tabAdvancesSlides}
          isHomepageCarousel={true}
        >
          {carousel.carouselPanelsCollection.items.map((card, i) => (
            <CarouselCard key={i} data={card} />
          ))}
        </Carousel>
      </div>
    );
  }
}

HomepageCarousel.propTypes = {
  carousel: PropTypes.object.isRequired,
};